<div class="message-bar-container">
  <span>{{message}}</span>
</div>
